import { createSelector } from "reselect"
import { getBasePositionSet } from "selectors/base"
import { getSegment as getHeaderSegment } from "modules/analyze-header/selectors/segment"
import { getFilter as getHeaderFilter } from "modules/analyze-header/selectors/filters"
import { computeEffectiveFilterScope, computeHasTagOrAttributeFilter, computeScopedBaseSegment } from "helpers/filter-scope"
import { getIsActive } from "modules/portfolio-root/selectors/portfolios"
import { getEffectiveFilterScope } from "./filters"

const getBaseFilterScope = createSelector(
  [getEffectiveFilterScope, getIsActive, getHeaderFilter],
  (effectiveFilterScope, isActive: boolean, headerFilter) => computeEffectiveFilterScope(effectiveFilterScope, {
    hasBenchmark: isActive,
    hasSimulatedTrades: false,
    hasTagOrAttributeFilter: computeHasTagOrAttributeFilter(headerFilter),
  }),
)

export const getBasePositionSetWithSegment = createSelector(
  [getBasePositionSet, getHeaderSegment, getBaseFilterScope],
  (basePositionSet, headerSegment, baseFilterScope) => ({
    ...basePositionSet,
    segment: computeScopedBaseSegment(headerSegment, baseFilterScope),
  }),
)

export const getBaseSignature = createSelector(
  [getBasePositionSetWithSegment],
  ({ id, segment }) => `${id}${JSON.stringify(segment)}`,
)
